module.exports = __webpack_public_path__ + "f7073ab093aa36021795b6099ace5b26.pdf";